// Pushes a stable GA4 User-ID (and account-type user property) to the GTM
// dataLayer once analytics consent is granted. Consent state is bridged from
// vanilla-cookieconsent via the "sf:consent-updated" event (see gtag_bridge.js),
// avoiding a race against CookieConsent.run().
//
// install() wires the listeners and returns a teardown that also resets state,
// so application.js installs once and tests can install/teardown per case.

let analyticsGranted = false;
let lastPushedUid = null;

function pushUserId() {
  if (!analyticsGranted) return;

  const uid = document.querySelector('meta[name="analytics-uid"]')?.content;
  const userType = document.querySelector('meta[name="analytics-user-type"]')?.content;
  if (!uid || uid === lastPushedUid) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ user_id: uid, user_type: userType });
  lastPushedUid = uid;
}

function onConsentUpdated(event) {
  analyticsGranted = (event.detail?.accepted || []).includes("analytics");
  // Forget the last push on revoke so a later re-grant re-pushes the user_id
  // (the dataLayer persists across a Turbo session).
  if (!analyticsGranted) lastPushedUid = null;
  pushUserId();
}

export function install(target = document) {
  target.addEventListener("sf:consent-updated", onConsentUpdated);
  target.addEventListener("turbo:load", pushUserId);

  return () => {
    target.removeEventListener("sf:consent-updated", onConsentUpdated);
    target.removeEventListener("turbo:load", pushUserId);
    analyticsGranted = false;
    lastPushedUid = null;
  };
}
